const digits = (s) => (s || "").replace(/\D/g, "");

const waNumber = (phone) => {
    let d = digits(phone);
    if (d.length === 10) d = "91" + d;
    else if (d.length === 11 && d.startsWith("0")) d = "91" + d.slice(1);
    return d;
  };

const telHref = (phone) => {
    let d = digits(phone);
    if (d.length === 10) return "tel:+91" + d;
    if (d.startsWith("91")) return "tel:+" + d;
    return "tel:+" + d;
  };

const waHref = (phone, text) =>
    "https://wa.me/" + waNumber(phone) + (text ? "?text=" + encodeURIComponent(text) : "");

const fmtINR = (lakhs) => {
    if (lakhs == null || lakhs === "") return "—";
    const n = Number(lakhs);
    if (!isFinite(n)) return "—";
    if (n >= 100) return "₹" + (n / 100).toFixed(2).replace(/\.?0+$/, "") + " Cr";
    if (n >= 1) return "₹" + n.toFixed(2).replace(/\.?0+$/, "") + " L";
    return "₹" + Math.round(n * 100000).toLocaleString("en-IN");
  };

const fmtCents = (c) => {
    if (c == null || c === "") return "—";
    const n = Number(c);
    if (!isFinite(n)) return "—";
    return n.toFixed(2).replace(/\.?0+$/, "") + " cents";
  };

const timeAgo = (iso) => {
    if (!iso) return "";
    const d = new Date(iso),
      now = new Date(),
      s = Math.floor((now - d) / 1000);
    if (s < 0) {
      const f = -s;
      if (f < 3600) return "in " + Math.ceil(f / 60) + "m";
      if (f < 86400) return "in " + Math.ceil(f / 3600) + "h";
      return "in " + Math.ceil(f / 86400) + "d";
    }
    if (s < 60) return "just now";
    if (s < 3600) return Math.floor(s / 60) + "m ago";
    if (s < 86400) return Math.floor(s / 3600) + "h ago";
    if (s < 604800) return Math.floor(s / 86400) + "d ago";
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    });
  };

const fmtDate = (iso) =>
    iso
      ? new Date(iso).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "";

const fmtDateTime = (iso) =>
    iso
      ? new Date(iso).toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "";

// Today as YYYY-MM-DD in the device's local timezone (for <input type="date"> / date columns).
const todayISO = () => {
    const d = new Date();
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  };

const priceToBucket = (price) => {
    const n = Number(price);
    if (!isFinite(n)) return null;
    if (n <= 5) return "0-5L";
    if (n <= 10) return "5-10L";
    if (n <= 15) return "10-15L";
    if (n <= 20) return "15-20L";
    if (n <= 25) return "20-25L";
    if (n <= 30) return "25-30L";
    return "30L+";
  };

const _BUCKET_RANGES = {
    "0-5L": [0, 5],
    "5-10L": [5, 10],
    "10-15L": [10, 15],
    "15-20L": [15, 20],
    "20-25L": [20, 25],
    "25-30L": [25, 30],
    "30L+": [30, 1e9],
  };

const normBucket = (s) => {
    if (s == null) return "";
    return String(s).replace(/\s+/g, "").toUpperCase();
  };

const _BUCKET_LOOKUP = Object.fromEntries(
    Object.keys(_BUCKET_RANGES).map((k) => [normBucket(k), k]),
  );

const bucketIncludes = (bucket, price) => {
    const nb = normBucket(bucket);
    if (!nb) return false;
    if (nb === "PER-CENT" || nb === "PERCENT" || nb === "UNSPECIFIED") return true;
    const key = _BUCKET_LOOKUP[nb];
    if (!key) return false;
    if (price == null || price === "") return false;
    const x = _BUCKET_RANGES[key];
    const n = Number(price);
    if (!isFinite(n)) return false;
    return n >= x[0] && n <= x[1];
  };

const priceInRange = (bucket, price) => {
    const nb = normBucket(bucket);
    if (!nb || nb === "PER-CENT" || nb === "PERCENT" || nb === "UNSPECIFIED") return true;
    if (price == null || price === "") return false;
    const key = _BUCKET_LOOKUP[nb];
    if (!key) return false;
    const x = _BUCKET_RANGES[key];
    const n = Number(price);
    if (!isFinite(n)) return false;
    return n >= x[0] && n <= x[1];
  };

export { digits, waNumber, telHref, waHref, fmtINR, fmtCents, timeAgo, fmtDate, fmtDateTime, todayISO, priceToBucket, _BUCKET_RANGES, normBucket, _BUCKET_LOOKUP, bucketIncludes, priceInRange };
